import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/logo-svg.svg'


const _withScopeId = (n: any) => (_pushScopeId("data-v-7c7acb0a"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "rtio-asset-management",
    style: {"height":"50px"}
  })
], -1))
const _hoisted_2 = { class: "nav-container" }
const _hoisted_3 = {
  class: "d-flex flex-column",
  style: {"min-width":"55px","width":"55px !important"}
}
const _hoisted_4 = {
  key: 0,
  class: "filters-panel width-full"
}

import router from "@/router";
import { useAuthStore } from "@/store/auth";
import { useFilterStore } from "@/store/filter";
import FilterList from "@/components/base/filters/FilterList.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'DefaultLayout',
  setup(__props) {

const auth = useAuthStore();
const filterStore = useFilterStore();

const pages = [
  {
    name: "Asset Management Plans",
    path: "/asset-management-plans",
    icon: "mdi-notebook-outline",
  },
  {
    name: "Functional Locations",
    path: "/functional-locations",
    icon: "mdi-format-list-bulleted-square",
  },
  {
    name: "Functional Location Tree",
    path: "/functional-location-tree",
    icon: "mdi-file-tree-outline",
  },
  {
    name: "Workorders",
    path: "/workorders",
    icon: "mdi-account-hard-hat",
  },
  {
    name: "Tactics",
    path: "/tactics",
    icon: "mdi-clipboard-clock-outline",
  },
  {
    name: "Metrics",
    path: "/metrics",
    icon: "mdi-chart-line",
  },
  {
    name: "Users",
    path: "/users",
    icon: "mdi-account-group",
  },
  {
    name: "Settings",
    path: "/settings",
    icon: "mdi-cog",
  },
];

const logout = () => {
  auth.reset();
  router.push("/login");
};

return (_ctx: any,_cache: any) => {
  const _component_v_app_bar_title = _resolveComponent("v-app-bar-title")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_app_bar = _resolveComponent("v-app-bar")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_navigation_drawer = _resolveComponent("v-navigation-drawer")!
  const _component_v_main = _resolveComponent("v-main")!
  const _component_v_app = _resolveComponent("v-app")!

  return (_openBlock(), _createBlock(_component_v_app, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_app_bar, {
        dark: "",
        app: "",
        flat: "",
        color: "grey-lighten-2"
      }, {
        append: _withCtx(() => [
          _createVNode(_component_v_menu, { "offset-y": "" }, {
            activator: _withCtx(({ props }) => [
              _createVNode(_component_v_btn, _mergeProps({
                icon: "",
                dark: ""
              }, props), {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, { icon: "mdi-account" })
                ]),
                _: 2
              }, 1040)
            ]),
            default: _withCtx(() => [
              _createVNode(_component_v_list, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_list_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, {
                        class: "mr-2",
                        icon: "mdi-account"
                      }),
                      _createTextVNode(" " + _toDisplayString(_unref(auth).state.user?.email), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_list_item, { onClick: logout }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, {
                        class: "mr-2",
                        icon: "mdi-logout"
                      }),
                      _createTextVNode(" Logout ")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _createVNode(_component_v_app_bar_title, null, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_navigation_drawer, {
        permanent: "",
        rail: _unref(filterStore).state.name && !_unref(filterStore).state.drawer,
        width: 310
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_v_btn, {
                class: "mx-auto my-1",
                icon: "mdi-filter",
                flat: "",
                density: "comfortable",
                disabled: !_unref(filterStore).state.name,
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(filterStore).state.drawer = !_unref(filterStore).state.drawer))
              }, null, 8, ["disabled"]),
              _createVNode(_component_v_divider),
              _createVNode(_component_v_list, {
                density: "compact",
                nav: ""
              }, {
                default: _withCtx(() => [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(pages, (page, i) => {
                    return _createVNode(_component_v_tooltip, {
                      key: i,
                      text: page.name
                    }, {
                      activator: _withCtx(({ props }) => [
                        _createVNode(_component_v_list_item, _mergeProps({ ref_for: true }, props, {
                          to: page.path
                        }), {
                          default: _withCtx(() => [
                            _createVNode(_component_v_icon, null, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(page.icon), 1)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1040, ["to"])
                      ]),
                      _: 2
                    }, 1032, ["text"])
                  }), 64))
                ]),
                _: 1
              })
            ]),
            (_unref(filterStore).state.name)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createVNode(FilterList, { class: "py-2 px-3" })
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }, 8, ["rail"]),
      _createVNode(_component_v_main, null, {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      })
    ]),
    _: 3
  }))
}
}

})